import ComponentButton from './Button';
import ComponentFadeContainer from './FadeContainer';
import ComponentInput from './Input';
import ComponentTooltip from './Tootip';

export const Button = ComponentButton;
export const FadeContainer = ComponentFadeContainer;
export const Input = ComponentInput;
export const Tootip = ComponentTooltip;
